// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"pu_a bhb_rh bhb_tu","ForumSearch__img":"pu_b","ForumSearch__searchAdsAndShoppingAds":"pu_c","ForumSearch__results--empty":"pu_e"};